;(function() {
    const tip = document.createElement('div')
    tip.classList.add('tooltip')
    document.querySelector('.page').append(tip)
    
    const mouseMove = (e) => {
        const elems = document.querySelectorAll('[data-tooltip]')
        if (!(elems.length > 0)) return 
        let { clientX, clientY } = e
        let current 
        for (let i = 0; i < elems.length; i++) {
            const elem = elems[i];
            if (elem.contains(e.target)) {
                current = elem
            }
            
        }
        if (current) {
            let direct = current.getAttribute('data-direct') || 'top'
            tip.classList.remove('right')
            tip.classList.remove('top')
            tip.classList.add(direct)

            let text = current.getAttribute('data-tooltip') || ''
            tip.textContent = text
            tip.style.top = clientY + 'px'
            tip.style.left = clientX + 'px'
            tip.classList.add('show')
        } else {
            tip.classList.remove('show')
        }
    }

    window.addEventListener('mousemove', mouseMove)
})()
